const SIGNIN_KEY = "auth/SIGNIN";
const SIGNUP_KEY = "auth/SIGNUP";
const CHECK_BIN = "auth/checkBin";
export { SIGNUP_KEY, SIGNIN_KEY, CHECK_BIN };
